import React, { FC } from 'react';
import ExpandButton from './ExpandButton';
import Container from './Container';
import { BidChecklistProvider } from 'src/models/bids/BidChecklist/providers';
import { FeatureFlag, useFeatureFlag } from 'src/helpers/featureFlag';

interface IProps {
  bidId: string;
}

export const BidChecklist: FC<IProps> = props => {
  const { bidId } = props;
  const isChecklistAvailable = useFeatureFlag(FeatureFlag.Checklist);

  return (
    <>
      {isChecklistAvailable && bidId && (
        <BidChecklistProvider bidId={bidId}>
          <ExpandButton />
          <Container />
        </BidChecklistProvider>
      )}
    </>
  );
};
export default BidChecklist;
